/*
 * @Description:
 * @Date: 2025-06-18 15:32:21
 */

import http from '@/utils/http/axios';
import {
  IndividualInfoList,
  IndividualInfoDetail,
  UpdateExpiraAt,
  PlatformAudit,
  ParkAudit,
  GetInvoiceItem,
  AddCheck,
  AddIndividual,
  ModifyIndividual,
  ImportIndividual,
  Again,
  Cancel,
  CostItemList,
  CostItemDetail,
  UploadLicense
} from './types';
import {
  getInvoiceItemTranslator,
  individualInfoDetailTranslator,
  addIndividualPayloadTranslator
} from './translators';

enum Api {
  individualInfoList = '/front-end/business/individual/api/v2/pageList', // 个体信息列表
  individualInfoDetail = '/front-end/business/individual/api/v2/detail/:businessIndividualId', // 个体信息详情
  updateExpiraAt = '/front-end/business/individual/api/v2/updateExpiraAt', // 修改服务有效期
  platformAudit = '/front-end/business/individual/api/v2/platformAudit', // 平台审核
  parkAudit = '/front-end/business/individual/api/v2/parkAudit', // 园区审核
  getInvoiceItem = '/front-end/business/individual/api/v2/getInvoiceItem', // 查询一级开票类目
  getInvoiceSubItem = '/front-end/business/individual/api/v2/getInvoiceSubItem', // 查询二级开票类目
  addCheck = '/front-end/business/individual/api/v2/import/addCheck', // 新增个体时校验
  addIndividual = '/front-end/business/individual/api/v2/add', // 新增个体信息
  modifyIndividual = '/front-end/business/individual/api/v2/modify', // 修改个体信息
  individualExport = '/front-end/business/individual/api/v2/export', // 个体信息导出
  importIndividual = '/front-end/business/individual/api/v2/import/individual', // 批量导入
  again = '/front-end/business/individual/api/v2/import/individual/again/:excelCode', // 重新提交个体导入数据 该接口用于重新提交个人导入的Excel数据，通过传入数据列表和Excel编码进行处理。
  cancel = '/front-end/business/individual/api/v2/import/individual/cancel/:excelCode', // 取消导入个体信息接口 根据提供的Excel编码取消对应的个体信息导入任务
  originalExcel = '/front-end/business/individual/api/v2/export/original/excel/:excelCode', // -下载原上传EXCEL
  exportDataPackage = '/front-end/business/individual/api/v2/exportDataPackage',
  exportIndividual = '/front-end/business/individual/api/v2/exportIndividual',
  uploadLicense = '/front-end/business/individual/api/v2/uploadLicense', // 营业执照识别
  // 成本列支
  costItemList = '/front-end/business/individual/api/v2/costItemList', // 成本列支列表
  costItemDownload = '/front-end/business/individual/api/v2/costItemDownload', // 成本列支单条下载 实时下载
  costItemExport = '/front-end/business/individual/api/v2/costItemExport', // 成本列支导出全部附件 到下载中心
  costItemDetail = '/front-end/business/individual/api/v2/costItemDetail' // 成本列支详情
}

const yApi = {
  // yapi: 1271
};

/**
 * 个体信息列表接口
 */
export const individualInfoList: IndividualInfoList = params =>
  http.request(
    {
      url: Api.individualInfoList,
      method: 'POST',
      params
    },
    { ...yApi }
  );

/**
 * 个体信息详情接口
 */
export const individualInfoDetail: IndividualInfoDetail = async params => {
  const resp = await http.request(
    {
      url: Api.individualInfoDetail,
      method: 'GET',
      params
    },
    { ...yApi }
  );
  return individualInfoDetailTranslator(resp);
};

/**
 * 修改服务有效期接口
 */
export const updateExpiraAt: UpdateExpiraAt = params =>
  http.request(
    {
      url: Api.updateExpiraAt,
      method: 'POST',
      params
    },
    { ...yApi }
  );

/**
 * 平台审核接口
 */
export const platformAudit: PlatformAudit = params =>
  http.request(
    {
      url: Api.platformAudit,
      method: 'POST',
      params
    },
    { ...yApi }
  );

/**
 * 园区审核接口
 */
export const parkAudit: ParkAudit = params =>
  http.request(
    {
      url: Api.parkAudit,
      method: 'POST',
      params: addIndividualPayloadTranslator(params)
    },
    { ...yApi }
  );
/**
 * 查询开票类目下拉框接口
 */
export const getInvoiceItem: GetInvoiceItem = async params => {
  const resp = await http.request(
    {
      url: Api.getInvoiceItem,
      method: 'POST',
      params
    },
    { ...yApi }
  );
  return getInvoiceItemTranslator(resp);
};
/**
 * 查询开票二级类目下拉框接口
 */
export const getInvoiceSubItem: GetInvoiceItem = async params => {
  const resp = await http.request(
    {
      url: Api.getInvoiceSubItem,
      method: 'GET',
      params
    },
    { ...yApi }
  );

  return resp;
};
/**
 * 新增个体时校验接口
 */
export const addCheck: AddCheck = params =>
  http.request(
    {
      url: Api.addCheck,
      method: 'POST',
      params
    },
    { ...yApi }
  );

/**
 * 新增个体信息接口
 */
export const addIndividual: AddIndividual = async params =>
  http.request(
    {
      url: Api.addIndividual,
      method: 'POST',
      params: addIndividualPayloadTranslator(params)
    },
    { ...yApi }
  );

/**
 * 修改个体信息接口
 */
export const modifyIndividual: ModifyIndividual = params =>
  http.request(
    {
      url: Api.modifyIndividual,
      method: 'POST',
      params: addIndividualPayloadTranslator(params)
    },
    { ...yApi }
  );
export const individualExport = (params: { ids: number[] }) =>
  http.download({
    url: Api.individualExport,
    method: 'POST',
    params
  });
export const importIndividual: ImportIndividual = params =>
  http.uploadFile({
    url: Api.importIndividual + '?excelCode=' + params.excelCode,
    method: 'POST',
    params: { file: params.file }
  });
export const again: Again = params =>
  http.request(
    {
      url: Api.again,
      method: 'POST',
      params
    },
    { ...yApi }
  );
export const cancel: Cancel = params =>
  http.request(
    {
      url: Api.cancel,
      method: 'GET',
      params
    },
    { ...yApi }
  );
export const originalExcel = (params: Parameters<Cancel>[0]) =>
  http.download({
    url: Api.originalExcel,
    method: 'POST',
    params
  });
export const exportDataPackage = (params: { idList: number[] }) =>
  http.request({
    url: Api.exportDataPackage,
    method: 'POST',
    params
  });

export const exportAllDataPackage = async () =>
  http.download({
    url: Api.exportIndividual,
    method: 'POST',
    params: {}
  });
export const costItemList: CostItemList = params =>
  http.request({
    url: Api.costItemList,
    method: 'GET',
    params
  });
export const costItemDownload = (params: {
  individualId: number;
  id: number;
}) =>
  http.download({
    url: Api.costItemDownload,
    method: 'GET',
    params
  });
export const costItemExport = (params: {
  individualId: number;
  ids: string; // 逗号分隔
}) =>
  http.request({
    url: Api.costItemExport,
    method: 'GET',
    params
  });
export const costItemDetail: CostItemDetail = params =>
  http.request({
    url: Api.costItemDetail,
    method: 'GET',
    params
  });
/**
 * 营业执照识别
 * @description 上传营业执照图片地址，识别执照信息
 */
export const uploadLicense: UploadLicense = async params =>
  http.request({
    url: Api.uploadLicense,
    method: 'POST',
    params
  });
